/**
 * ProgressiveLoader — fade + slide-up entrance, driven by CSS
 * (`.udent-reveal` in index.css) rather than state: react-snap serialises
 * after effects, so a state-driven reveal was captured finished while the
 * client's first render started hidden — a hydration mismatch.
 *
 * Props: delay (ms), duration (ms), className.
 */
export const ProgressiveLoader = ({
    children,
    delay = 0,
    duration = 600,
    className = '',
}) => (
    <div
        className={`udent-reveal ${className}`.trim()}
        style={{ animationDelay: `${delay}ms`, animationDuration: `${duration}ms` }}
    >
        {children}
    </div>
);
